import React from "react"
import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { MediaOption } from "shared/ui/media-option/MediaOption"

import {
  GLOBAL_SEARCH_HISTORY_OPTION_TYPE,
  GlobalSearchHistoryOption
} from "features/global-search/types/GlobalSearch"

import { useGlobalSearchContext } from "../GlobalSearchContext"
import { useGlobalSearchInputContext } from "../GlobalSearchInputContext"
import { GlobalSearchListbox } from "./GlobalSearchListbox"
import { GlobalSearchListItem } from "./list-items/GlobalSearchListItem"

function toHistoryOption(query: string): GlobalSearchHistoryOption {
  return { type: GLOBAL_SEARCH_HISTORY_OPTION_TYPE, value: query, label: query }
}

export const GlobalSearchSearchHistory = React.memo(() => {
  const { t } = useTranslation()
  const { hasResults, history } = useGlobalSearchContext()
  const { inputValue } = useGlobalSearchInputContext()

  if (history.length === 0 || inputValue.length >= 2 || hasResults) return null

  return (
    <div className="global-search__tab-content global-search__search-history">
      <GlobalSearchListbox>
        <div className="global-search__options-group">
          <div className="global-search__options-group-header">
            <div className="global-search__options-group-title">
              {t("GlobalSearch.RecentSearches")}
            </div>
          </div>
          <div className="global-search__options-group-list">
            {history.map((query, index) => (
              <GlobalSearchListItem
                key={query}
                index={index}
                isTabActive
                option={toHistoryOption(query)}
                className="global-search__list-item--history"
              >
                <MediaOption.Root variant="inline">
                  <MediaOption.Media aria-hidden>
                    <Icon name={IconName.HISTORY} />
                  </MediaOption.Media>
                  <MediaOption.Label>{query}</MediaOption.Label>
                </MediaOption.Root>
              </GlobalSearchListItem>
            ))}
          </div>
        </div>
      </GlobalSearchListbox>
    </div>
  )
})
